import React, { FC, useMemo } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { CreateProductStepUpload } from './components/CreateProductStepUpload';
import { useGenerateProduct } from 'hooks/useGenerateProduct';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { useProductStore } from 'stores/product';

export const CreateProductUploadStep: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const { startGeneration, isPendingProfile, isPendingImages } = useGenerateProduct({
    onProfileGenerated: next,
  });

  const onFilePicked = (file: File | undefined) => {
    useProductStore.getState().reset();
    startGeneration();
  };

  const isLoading = useMemo(() => {
    return isPendingProfile || isPendingImages;
  }, [isPendingProfile, isPendingImages]);

  return (
    <StepLayout
      disclaimer={t('create-product-step.ai-disclaimer')}
      description={t('create-product-step.description')}
      title={t('create-product-step.title')}
      shouldSkip={!isLoading}
      nextButtonProps={{
        label: t('create-product-step.actions.next-button'),
        disabled: true,
      }}
    >
      <CreateProductStepUpload onFilePicked={onFilePicked} isLoading={isLoading} />
    </StepLayout>
  );
};
